import { useQueryClient } from '@tanstack/react-query'

import {
  useNotesServiceDeleteV1IndividualsByIndividualIdNotesByNoteId,
} from '../client/queries'
import {
  useNotesServiceGetV1IndividualsByIndividualIdNotesKey,
  useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey,
} from '../client/queries/common'

export const useDeleteNote = () => {
  const queryClient = useQueryClient()

  return useNotesServiceDeleteV1IndividualsByIndividualIdNotesByNoteId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesKey],
      })
      queryClient.invalidateQueries({
        queryKey: [useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey],
      })
    },
  })
}
